var APPLY_FILTER_GROUP = 'Apply Filter Group';
var DEFAULT_FILTERS_CHANGE = 'Default Filter Change';
var UPDATE_FILTER_GROUP = 'Update Filter Group';
var SAVE_NEW_FILTER_GROUP = 'Save new Filter Group';
var DELETE_FILTER_GROUP = 'Delete Filter Group';
var OPEN_NOTES_MODAL = 'Open Notes Modal';
var REPORT_DOWNLOAD = 'Download Report';
var UPLOAD_ATTACHMENT = 'Upload Attachment';
var REMOVE_ATTACHMENT = 'Remove Attachment';
var SAVE_AS_DRAFT = 'Save as Draft';
var EVENT_TYPES = {
  OPEN_NOTES_MODAL: OPEN_NOTES_MODAL,
  REMOVE_ATTACHMENT: REMOVE_ATTACHMENT,
  UPLOAD_ATTACHMENT: UPLOAD_ATTACHMENT,
  REPORT_DOWNLOAD: REPORT_DOWNLOAD,
  SAVE_AS_DRAFT: SAVE_AS_DRAFT,
  APPLY_FILTER_GROUP: APPLY_FILTER_GROUP,
  UPDATE_FILTER_GROUP: UPDATE_FILTER_GROUP,
  SAVE_NEW_FILTER_GROUP: SAVE_NEW_FILTER_GROUP,
  DELETE_FILTER_GROUP: DELETE_FILTER_GROUP,
  DEFAULT_FILTERS_CHANGE: DEFAULT_FILTERS_CHANGE
};
export default EVENT_TYPES;